export default __webpack_public_path__ + "static/media/Ballroll_00374.40cdf548.png";